import { Product } from '../types/Product';

export class Invoice {
    name = "";
    salesorderid = "";
    invoicenumber = "";
    invoiceid = "";
    new_teginvoice = "";
    state = "";
    products: ProductLineItem[] = new Array<ProductLineItem>();
}

export class ProductLineItem {
    productName = "";
    quantity = 0;
    productType = "";
}